import { render, staticRenderFns } from "./Segments.vue?vue&type=template&id=39d65dc0&scoped=true"
import script from "./Segments.vue?vue&type=script&lang=ts"
export * from "./Segments.vue?vue&type=script&lang=ts"
import style0 from "./Segments.vue?vue&type=style&index=0&id=39d65dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d65dc0",
  null
  
)

export default component.exports